import api from '@/api/fyApi';
import BaseModule from "@/common/BaseModule";
import { Module } from "vuex";
import { LOAD_MOVIE_AUTHORS_PAGE, LOAD_SEO } from '../protocols';
export interface State {
    speakers: MovieSpeaker[],
    movies: MovieAlbum[],
}

class MovieAuthors extends BaseModule<State>{
    constructor() {
        super(LOAD_MOVIE_AUTHORS_PAGE[0])
    }
    generate(): Module<State, any> {
        return {
            namespaced: true,
            state: {
                speakers: [],
                movies: [],
            },
            mutations: {
                updateSpeakers(state, data) {
                    state.speakers = data;
                },
                updateMovies(state, data) {
                    state.movies = data;
                }
            },
            actions: {
                async loadData({ commit }) {
                    let { speaker_list, movie_list } = await api.getMovieAuthors()
                    commit('updateSpeakers', speaker_list)
                    commit('updateMovies', movie_list)
                },
                [LOAD_MOVIE_AUTHORS_PAGE[1]]({ dispatch }) {
                    return Promise.all([
                        dispatch('loadData'),
                        dispatch(LOAD_SEO, { file: 'speakers' }, { root: true })
                    ])
                }
            }
        }
    }
}

export default new MovieAuthors();